// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
	CustomerServiceOutlined,
	QuestionCircleOutlined,
	ThunderboltOutlined,
	UnorderedListOutlined,
	RobotOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import useAuthContext from 'context/useAuthContext';
import useGlobalContext from '../../../context/useGlobalContext';
import { AuditOutlined, SlidersOutlined } from '@ant-design/icons/lib/icons';

// icons
const icons = {
	customerServiceOutlined: CustomerServiceOutlined,
	questionCircleOutlined: QuestionCircleOutlined,
	thunderboltOutlined: ThunderboltOutlined,
	unorderedListOutlined: UnorderedListOutlined,
	slidersOutlined: SlidersOutlined,
	robotOutlined: RobotOutlined,
	auditOutlined: AuditOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function SupportMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();
	let items: NavItemType = {};

	if (permissions) {
		items = {
			id: 'group-support',
			title: 'Support',
			type: 'group',
			children: []
		};

		if (
			permissions.some((el: string) => {
				return el === 'View_Feedback_Review_Systems';
			})
		) {
			items.children.push({
				id: 'core-support-feedback-reviews',
				title: 'Feedback Review System',
				type: 'item',
				url: '/app/support/feedback-review-system',
				icon: icons.auditOutlined,
				breadcrumbs: true
			});
		}

		items.children.push({
			id: 'core-support-tickets',
			title: 'Support Tickets',
			type: 'item',
			url: '/app/support/tickets',
			icon: icons.thunderboltOutlined,
			breadcrumbs: true
		});

		items.children.push({
			id: 'core-support-chatbot',
			title: 'Chatbot',
			type: 'item',
			url: '/app/support/chatbot',
			icon: icons.robotOutlined,
			breadcrumbs: true
		});

		/*items.children.push({
            id: 'core-support-faqs',
            title: 'FAQs',
            type: 'item',
            url: '/app/support/faqs',
            icon: icons.questionCircleOutlined,
            breadcrumbs: false
        });*/

		if (activeCompany.value == null) {
			if (
				permissions.some((el: string) => {
					return el === 'Base_Setting' || el === 'Manage_Support_Ticket_Response';
				})
			) {
				let support_setting = {
					id: 'core-setting-support',
					title: 'Support',
					type: 'collapse',
					icon: icons.slidersOutlined,
					breadcrumbs: true,
					children: []
				};

				support_setting.children.push({
					id: 'core-setting-support-type',
					title: 'Support Type',
					type: 'item',
					url: '/app/settings/support/types',
					breadcrumbs: true
				});

				if (
					permissions.some((el: string) => {
						return el === 'Manage_Support_Ticket_Response';
					})
				) {
					support_setting.children.push({
						id: 'core-setting-support-ticket-response',
						title: 'Support Ticket Response',
						type: 'item',
						url: '/app/settings/support/responses',
						breadcrumbs: true
					});
				}

				items.children.push(support_setting);
			}
		}
	}

	return items;
}
